import { TimelineParty } from '../../slices/marketplace/timeline/models/enums/timeline-party.enum';

export enum TransactionDocumentsStage {
    BuyerDrafts = 1,
    SellerRedlines = 2,
}

export enum TransactionDocumentVersionStage {
    BuyerDraft = 1,
}

export interface TransactionDocumentVersion {
    id: number;
    documentType: string;
    stage: TransactionDocumentVersionStage;
    party: TimelineParty;
    uploaderName: string;
    uploaderOrganizationName?: string;
    onBehalfOfName: string;
    uploadedAt: string;
    comment?: string;
    fileName: string;
}

export interface TransactionDocuments {
    engagementId: number;
    stage: TransactionDocumentsStage;
    requiredDocumentTypes: string[];
    isRequiredListConfirmed: boolean;
    requiredListLastEditedByName?: string;
    requiredListLastEditedAt?: string;
    documentTypesWithUploads: string[];
    commonDocumentTypes: string[];
    versions: TransactionDocumentVersion[];
    currentUserParty: TimelineParty;
    canUpload: boolean;
    canEditRequiredList: boolean;
    canPostInitialDrafts: boolean;
    canAddCommonDocumentTypes: boolean;
}
